/* eslint-disable callback-return */

/** @name: lnk-form-rules 此文件是lnk-form组件的，规则配置文件，如需特殊规则校验，可以在这个文件中进行自定义，并配置到组件内，此文件的所有规则函数，绑定在window中的 formRules 对象中。
 * @createdby:Wangyue
 *
 * 需要注意的是，在这个文件中配置的规则函数，其函数名，对应的是lnk-form组件中，rule下的ruleType的值。两者需要相等。
 * 在需要特殊验证时，需要把这个文件，提前引入到页面中，然后引入lnk-form.vue.js文件，使用组件。
 *
 *
 */
const formRules = {
    tel: function(rule, value, callback){
        const isMob= /0\d{2}-\d{7,8}/;// 座机格式
        if(isMob.test(value) || value === '' || value === undefined){
            callback();
        } else{
            callback(new Error('请按要求输入电话号码'));
        }
    },
    phone: function(rule, value, callback){
        const isPhone = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/;// 手机号码
        if(isPhone.test(value || value === '' || value === undefined)){
            callback();
        } else{
            callback(new Error('请按要求输入手机号码'));
        }
    },
    email: function(rule, value, callback){
        const isEmail = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/; // 电子邮箱
        if(isEmail.test(value) || value === '' || value === undefined){
            callback();
        } else{
            callback(new Error('请按要求输入电子邮箱'));
        }
    }
};
if(window!==undefined){
    window.lnkFormRules = formRules;
}
export default formRules;
